import { motion } from "framer-motion";
import { STATS } from "../../data/content";

export const Stats = () => {
  return (
    <section data-testid="stats-band" className="relative py-20 lg:py-28 bg-[#0B1120]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#F5B800] mb-12">Our Impact</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid="stat-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <p className="font-display text-5xl lg:text-7xl font-extrabold tracking-tighter text-white">
                {s.value}
              </p>
              <div className="h-[2px] w-8 bg-[#1C9FD8] my-4" />
              <p className="text-sm text-slate-400 tracking-wide">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
